export default __webpack_public_path__ + "static/media/cog-icon.e09743e2.svg";